import React from 'react';
import * as d3 from '../../../libraries/d3';
import DateHelper from '../../DateHelper/DateHelper';

export default class AreaChartToolTip extends React.Component {
  constructor(props) {
    super(props)
  };

  componentDidMount() {
    var yAxisDetails = this.props.yAxisDetails
    var yDataColumns = yAxisDetails.map(detail => detail.data_column_name)
    var listeningRect = this.props.bounds()
      .append('rect')
      .attr('class', 'tool-tip-listening-rec')
      .attr('id', `tool-tip-listening-rec-${this.props.report_details.id}`)
      .attr('width', this.props.dimensions().boundedWidth)
      .attr('height', this.props.dimensions().boundedHeight)
      .style('fill', 'transparent')

    var toolTipGroup = this.props.bounds()
      .append("g")
      .attr("class", "tool-tip-group");

    var details = toolTipGroup.selectAll('.circle-per-line')
      .data(yDataColumns)
      .enter()
      .append("g")
      .attr("class", "tool-tips");

    var circles = details.append('circle')
      .attr('r', 4)
      .attr('fill', 'white')
      .style('opacity', 0)
      .style('z-index', 10)
      .attr("class", `tool-tips circle-tips-${this.props.report_details.id}`);


    var toolLinePath = toolTipGroup.selectAll('.tool-tip-line')
      .data(yDataColumns)
      .enter()
      .append("g")
      .attr("class", "tool-tips");

    toolLinePath.append("line") // this is the black vertical line to follow mouse
      .style("stroke", "black")
      .style("stroke-width", "1px")
      .style("opacity", 0)
      .attr("class", `tool-tips line-tips-${this.props.report_details.id}`)

    this.setState({
      hasRunMount: true,
    });
  };

  componentDidUpdate(prevProps) {
    let xScale = d3.scaleTime().domain(d3.extent(this.props.data, (d) => DateHelper.parseDate(d[this.props.xAxisDetail.data_column_name], this.props.date_format))).nice().range([0, this.props.dimensions().boundedWidth]);
    let yScale = this.props.dataType == 'percent' ? d3.scaleLinear().domain([0, 100]).nice().range([this.props.dimensions().boundedHeight, 0]) : d3.scaleLinear().domain([this.props.yMaxMinDetailndValue.min, this.props.yMaxMinDetailndValue.max]).nice().range([this.props.dimensions().boundedHeight, 0]);
    var xDateAccessor = this.props.xDateAccessor
    var dataType = this.props.dataType
    var data = this.props.data
    // var stackedData = this.state.stackedData
    var yAxisDetails = this.props.yAxisDetails
    var dimensions = this.props.dimensions()
    var dataDetails = this.props.report_details.data_details.map(detail => detail)
    var removedDataDetails = this.props.removedDataDetails
    var passbackToChartWrapper = this.props.onClickToolTip
    var keys = []

    this.props.yAxisDetails.forEach((detail) => {
      keys.push(detail.data_column_name);
    });

    var listeningRect = d3.select(`#tool-tip-listening-rec-${this.props.report_details.id}`)
    listeningRect.on('mousemove', onMouseMove)
      .on('mouseleave', onMouseLeave)

    var circles = d3.selectAll(`.circle-tips-${this.props.report_details.id}`)
    var linePath = d3.selectAll(`.line-tips-${this.props.report_details.id}`)
    var yText = d3.selectAll('.y-text')
    var xText = d3.selectAll('.x-text')

    function onMouseMove() {
      var mousePosition = d3.pointer(event, this);
      var hoveredDate = xScale.invert(mousePosition[0]);
      var getDistanceFromHoverdDate = d => Math.abs(xDateAccessor(d) - hoveredDate);
      var closestIndex = d3.scan(data, (a, b) => getDistanceFromHoverdDate(a) - getDistanceFromHoverdDate(b));
      var closestDataPoint = data[closestIndex]

      var closestXValue = xDateAccessor(closestDataPoint)
      var closestYValues = yAxisDetails.map(detail => closestDataPoint[detail.data_column_name])
      circles
        .attr('cx', xScale(closestXValue))
        .attr('cy', (d, i) => {
          var scaleReference = d3.stack()
          .keys(keys)
          ([closestDataPoint])
          var dataPoint = scaleReference.find(sd => sd.key === d)

          return yScale(dataType === 'percent' ? parseFloat(dataPoint[0][1] * 100) : dataPoint[0][1]) + 2 
        })
        .attr('stroke', d => dataDetails.find(detail => detail.data_column_name === d).color)
        .attr('stroke-width', 2)
        .style('opacity', (d) => removedDataDetails && removedDataDetails.length && removedDataDetails.find(detail => detail.data_column_name === d) ? 0 : 1)

      linePath
        .attr('x1', xScale(closestXValue))
        .attr('y1', 0)
        .attr('x2', xScale(closestXValue))
        .attr('y2', dimensions.boundedHeight)
        .style('opacity', 1)

      passbackToChartWrapper(closestDataPoint)
    };

    function onMouseLeave() {
      circles.style('opacity', 0);
      yText.style('opacity', 0);
      xText.style('opacity', 0);
      linePath.style('opacity', 0);
    };
  };

  render() {
    return (
      null
    );
  };

  formatCurrency(num) {
    return I18n.t('number.currency.format.unit') + numeral(num).format('0' + I18n.t('number.currency.format.delimiter') + '0.00');
  };
};